import { render, staticRenderFns } from "./ActionButton.vue?vue&type=template&id=65f0a284&"
import script from "./ActionButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ActionButton.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ActionButton.vue?vue&type=style&index=0&id=65f0a284&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports